import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Cookie } from "lucide-react";

const KEY = "sku-consent";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setVisible(true);
    } catch { setVisible(true); }
  }, []);

  const decide = (accepted) => {
    try { localStorage.setItem(KEY, accepted ? "accepted" : "declined"); } catch { /* ignore */ }
    if (accepted && typeof window.__loadAnalytics === "function") window.__loadAnalytics();
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-banner"
          role="dialog"
          aria-label="Cookie-godkännande"
          className="fixed z-[80] inset-x-4 bottom-4 sm:inset-x-auto sm:right-6 sm:bottom-6 sm:max-w-sm rounded-3xl bg-white border border-slate-200/80 shadow-[0_25px_60px_-15px_rgba(7,22,44,0.3)] p-5 pb-[calc(1.25rem+env(safe-area-inset-bottom))] sm:pb-5"
          initial={{ opacity: 0, y: 24, scale: 0.98 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 24, scale: 0.98 }}
          transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
        >
          <div className="flex items-start gap-3">
            <span className="h-10 w-10 rounded-full bg-brand-iceBg flex items-center justify-center shrink-0">
              <Cookie className="h-5 w-5 text-brand-blue" strokeWidth={1.75} />
            </span>
            <div>
              <p className="font-semibold text-brand-ink text-sm">Vi använder cookies</p>
              <p className="mt-1 text-xs text-slate-500 leading-relaxed">
                Vi använder analyscookies (Google Analytics) för att förstå hur besökare använder sajten. Du väljer själv.
              </p>
            </div>
          </div>
          <div className="mt-4 flex gap-2.5">
            <button
              onClick={() => decide(true)}
              data-testid="cookie-accept"
              className="flex-1 rounded-full bg-brand-blue text-white text-sm font-semibold px-4 py-2.5 hover:bg-brand-blueHover active:scale-[0.98] transition-all"
            >
              Acceptera
            </button>
            <button
              onClick={() => decide(false)}
              data-testid="cookie-decline"
              className="flex-1 rounded-full bg-white text-brand-ink border border-slate-200 text-sm font-semibold px-4 py-2.5 hover:border-brand-blue hover:text-brand-blue transition-colors"
            >
              Endast nödvändiga
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
